import { constant } from "common/constant";
import * as yup from "yup";

export const jobProfileSchema = yup.object({
  title: yup.string().required(constant.requiredTitle),
  department: yup.string().required(constant.requiredDepartment),
  hiringManager: yup.string().required(constant.requiredHiringManager),
  assignedRecruiter: yup.string().required(constant.requiredAssignedRecruiter),
  industry: yup.string().required(constant.requiredIndustry),
  salary: yup.string().required(constant.requiredSalary),
  description: yup.string().required(constant.requiredDescription),
  requirements: yup.string().required(constant.requiredRequirements),
  benefits: yup.string().required(constant.requiredBenefits),
  attachments: yup.string(),
});
